export const isValidEmail = (email) => {
  const removeSpacesEmail = / /g;
  const emailWithoutSapces = email.replace(removeSpacesEmail, "");
  const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (validEmailRegex.test(emailWithoutSapces));
};
